import { videoUrl } from '@helpers/cloudinary';
import { getSrcs, imageUrl } from '@helpers/image';
import { Device, until } from '@helpers/media';
import { BackgroundValues } from '@stories/Components/Breadcrumb/Breadcrumb';
import CarouselProvider from '@stories/Components/Misc/Carousel/CarouselProvider/CarouselProvider';
import Controls from '@stories/Components/Misc/Carousel/Controls/Controls';
import SimpleTrack from '@stories/Components/Misc/Carousel/SimpleTrack/SimpleTrack';
import SectionHeader from '@stories/Components/SectionHeader/SectionHeader';
import * as React from 'react';
import S from './ContentCarousel.styles';
import ValuesList from './KeyValuesList/KeyValuesList';
import Testimonial from './Testimonial/Testimonial';
function isKeyValueItems(values) {
    return values[0].key !== undefined;
}
function isTestimonials(values) {
    return values[0].text !== undefined;
}
const ContentCarousel = ({ anchorId, background, items, values, carouselPosition, ...rest }) => {
    return (React.createElement(S.Container, { id: anchorId, "data-background": background && background !== '' ? background : BackgroundValues.Beige },
        React.createElement(SectionHeader, { ...rest }),
        React.createElement(S.Inner, { "data-carousel-position": carouselPosition ?? 'right' },
            isKeyValueItems(values) && React.createElement(ValuesList, { values: values }),
            isTestimonials(values) && (React.createElement(Testimonial, { values: values, background: background && background !== '' ? background : BackgroundValues.Beige })),
            React.createElement(CarouselProvider, { count: items.length },
                React.createElement(S.CarouselContainer, null,
                    React.createElement(S.CarouselWrapper, null,
                        React.createElement(SimpleTrack, null, items.map((item) => (React.createElement(S.Item, { key: `key-value-image-${item.id}` }, item.image ? (renderImage(item.image)) : item.video ? (React.createElement(S.ImageWrapper, null,
                            React.createElement(S.Video, { controls: true, playsInline: true, poster: item.video?.previewImage
                                    ? imageUrl(item.video?.previewImage, {
                                        width: 797,
                                        height: 448,
                                    })
                                    : videoUrl(item.video?.videoId ?? '', {
                                        format: 'jpg',
                                    }), preload: "metadata" },
                                React.createElement("source", { type: "video/webm", src: videoUrl(item.video?.videoId ?? '', {
                                        format: 'webm',
                                    }) }),
                                React.createElement("source", { type: "video/mp4", src: videoUrl(item.video?.videoId ?? '', {
                                        format: 'mp4',
                                    }) })))) : null))))),
                    items.length > 1 && (React.createElement(Controls, { paginationTitle: `${isKeyValueItems(values) ? 'Key Value Pair' : 'Testimonial'} carousel controls`, wrap: false })))))));
    function renderImage(image) {
        const srcs = getSrcs(image, 798, 375, 6, 9 / 16, image.noCrop ? { rmode: 'pad' } : {});
        return (React.createElement(S.ImageWrapper, null,
            React.createElement(S.Image, { sizes: `${until(Device.Tablet)} 100vw, ${until(Device.Tablet)} 66vw, ${until(Device.DesktopLarge)} 52.5vw, 798px`, src: srcs[0].split(' ')[0], srcSet: srcs.join(','), role: !image.altText ? 'presentation' : undefined, loading: "lazy", alt: image.altText })));
    }
};
export default ContentCarousel;
